import { render, staticRenderFns } from "./UpsertAppointmentView.vue?vue&type=template&id=26516aab&scoped=true&"
import script from "./UpsertAppointmentView.vue?vue&type=script&lang=ts&"
export * from "./UpsertAppointmentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26516aab",
  null
  
)

export default component.exports